import './TopMenu.css';

import React from 'react';
import {NavLink} from 'react-router-dom';


const selectedStyle = {
  "fontWeight":"bold",
};

function TopMenu(){

  return(
      <nav className="topMenu row nowrap centerContent">
        <div className="contentButtons row nowrap spaceBetweenContent">
          <div className="backgroundEIC button shadow column spaceAroundContent centerText">
            <NavLink className="navLink" to="/inicio" activeStyle={selectedStyle}>
              <span>Início</span>
            </NavLink>
          </div>
          <div className="backgroundEIC button shadow centerText column spaceAroundContent">
            <NavLink className="navLink" to="/rank" activeStyle={selectedStyle}>
              Rank
            </NavLink>
          </div>
          <div className="backgroundEIC button shadow centerText column spaceAroundContent">
            <NavLink className="navLink" to="/creditos" activeStyle={selectedStyle}>
              Créditos
            </NavLink>
          </div>
        </div>
      </nav>
  );
}

export default TopMenu;
